(function () {
  'use strict';

  var STORAGE_KEY = 'vvWellnessQuiz';
  var RESULT_KEY = 'finalResult';
  var STATE_VERSION = 1;
  var LOADING_DELAY_MS = 2000;
  var AUTO_ADVANCE_DELAY_MS = 225;
  var FALLBACK_PATH = '/pages/question-1';

  var RESULT_PATHS = Object.freeze({
    'inner-bloom': '/pages/inner-bloom-result',
    'inner-calm': '/pages/inner-calm-result',
    'inner-grow': '/pages/inner-grow-result',
    'inner-balance': '/pages/inner-balance-result'
  });

  var PAGES = Object.freeze({
    'question-1': {
      continueSelector: '.i5dltNEKYhTYnuJhs',
      nextPath: '/pages/question-2',
      answers: [
        ['.iryWtncWKwCkxoXEV', 'better-digestion', 'inner-bloom'],
        ['.isinV2DGgfAvBdOBU', 'better-sleep-relaxation', 'inner-calm'],
        ['.iYlNygBzbpQthznDp', 'hair-skin-nails', 'inner-grow'],
        ['.i1b9CJ8q3Ak8VWPRa', 'daily-wellness-nutrition', 'inner-balance']
      ]
    },
    'question-2': {
      continueSelector: '.iNMyHrtkrbRNuHOHm',
      nextPath: '/pages/question-3',
      answers: [
        ['.iAVM8QATrngUH172Q', 'calm-relaxed', 'inner-calm'],
        ['.i08Pn6dY49F2Foxwk', 'energized-balanced', 'inner-balance'],
        ['.iN90EmMzkdwOuNQcF', 'light-comfortable', 'inner-bloom'],
        ['.iOOsluEb49vlLkskN', 'confident-appearance', 'inner-grow']
      ]
    },
    'question-3': {
      continueSelector: '.iNhACyLikz057gTzZ',
      nextPath: '/pages/question-4',
      answers: [
        ['.ibMVu6evXKejm8fZ7', 'consistently-energized', null],
        ['.icGnZ9mkCmEx37E5A', 'morning-slumps', null],
        ['.ikhdQpeX9CjA673mn', 'afternoon-crashes', null],
        ['.iRu8S9ZSJL5ekq1J1', 'often-fatigued', null]
      ]
    },
    'question-4': {
      continueSelector: '.i12B8RRImghSJ5nGq',
      nextPath: '/pages/loading',
      answers: [
        ['.iOyYPiZo0AhtB4sP0', 'clean-natural-ingredients', null],
        ['.ie5x4y8imFCo3NUuP', 'simplicity-consistency', null],
        ['.ic6ui8azJii0bB2wl', 'long-term-wellbeing', null],
        ['.i6KAKZUEbWMlJXABC', 'visible-fast-results', null]
      ]
    }
  });

  function emptyState() {
    return { version: STATE_VERSION, answers: {} };
  }

  function readState() {
    try {
      var parsed = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY));
      if (!parsed || parsed.version !== STATE_VERSION || !parsed.answers || typeof parsed.answers !== 'object') {
        return emptyState();
      }

      var sanitized = emptyState();
      Object.keys(PAGES).forEach(function (question) {
        var stored = parsed.answers[question];
        if (!stored || typeof stored.answer !== 'string') return;

        var match = PAGES[question].answers.find(function (answerConfig) {
          return answerConfig[1] === stored.answer;
        });
        if (!match) return;

        sanitized.answers[question] = { answer: match[1], category: match[2] };
      });
      return sanitized;
    } catch (error) {
      return emptyState();
    }
  }

  function writeState(state) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      return true;
    } catch (error) {
      return false;
    }
  }

  function writeResult(result) {
    try {
      if (RESULT_PATHS[result]) {
        window.sessionStorage.setItem(RESULT_KEY, result);
      } else {
        window.sessionStorage.removeItem(RESULT_KEY);
      }
    } catch (error) {
      return;
    }
  }

  function readResult() {
    try {
      var result = window.sessionStorage.getItem(RESULT_KEY);
      return RESULT_PATHS[result] ? result : null;
    } catch (error) {
      return null;
    }
  }

  function currentHandle() {
    var parts = window.location.pathname.split('/').filter(Boolean);
    return parts[0] === 'pages' && parts[1] ? parts[1] : '';
  }

  function injectBehaviorStyles() {
    if (document.getElementById('vv-quiz-behavior-styles')) return;

    var style = document.createElement('style');
    style.id = 'vv-quiz-behavior-styles';
    style.textContent = [
      '.vv-quiz-answer { cursor: pointer; }',
      '.vv-quiz-answer:focus { outline: none; }',
      '.vv-quiz-answer:focus:not(:focus-visible) { box-shadow: none; }',
      '.vv-quiz-answer:focus-visible { outline: none; box-shadow: 0 0 0 3px currentColor; }',
      '.vv-quiz-answer.vv-quiz-selected { border-color: currentColor !important; border-width: 2px !important; }',
      '.vv-quiz-continue { display: none !important; }'
    ].join('');
    document.head.appendChild(style);
  }

  function setContinueEnabled(link, enabled) {
    link.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    link.classList.add('vv-quiz-continue');
  }

  function calculateResult(state) {
    var required = ['question-1', 'question-2', 'question-3', 'question-4'];
    var isComplete = required.every(function (question) {
      return state.answers[question] && typeof state.answers[question].answer === 'string';
    });

    if (!isComplete) return null;

    var first = state.answers['question-1'].category;
    var second = state.answers['question-2'].category;
    if (!RESULT_PATHS[first] || !RESULT_PATHS[second]) return null;

    var scores = {};
    scores[first] = (scores[first] || 0) + 1;
    scores[second] = (scores[second] || 0) + 1;

    var highest = Math.max.apply(null, Object.keys(scores).map(function (category) {
      return scores[category];
    }));
    var leaders = Object.keys(scores).filter(function (category) {
      return scores[category] === highest;
    });

    return leaders.length === 1 ? leaders[0] : first;
  }

  function initializeQuestion(handle, config) {
    var continueLink = document.querySelector(config.continueSelector);
    if (!continueLink) return;

    injectBehaviorStyles();

    var state = readState();
    var selected = state.answers[handle] ? state.answers[handle].answer : null;
    var cards = [];
    var navigationPending = false;

    config.answers.forEach(function (answerConfig) {
      var card = document.querySelector(answerConfig[0]);
      if (!card) return;

      var parentCard = card.parentElement;
      if (
        parentCard &&
        window.getComputedStyle(card).borderRadius === '0px' &&
        window.getComputedStyle(parentCard).borderRadius !== '0px'
      ) {
        card = parentCard;
      }

      var answer = answerConfig[1];
      var category = answerConfig[2];
      cards.push(card);
      card.classList.add('vv-quiz-answer');
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-pressed', answer === selected ? 'true' : 'false');
      card.setAttribute('data-vv-answer', answer);

      if (answer === selected) card.classList.add('vv-quiz-selected');

      function chooseAnswer() {
        if (navigationPending) return;

        cards.forEach(function (otherCard) {
          otherCard.classList.remove('vv-quiz-selected');
          otherCard.setAttribute('aria-pressed', 'false');
        });

        card.classList.add('vv-quiz-selected');
        card.setAttribute('aria-pressed', 'true');
        state.answers[handle] = { answer: answer, category: category };
        var stateSaved = writeState(state);
        var result = null;

        if (handle === 'question-4') {
          result = calculateResult(state);
          writeResult(result);
        }

        setContinueEnabled(continueLink, handle !== 'question-4' || Boolean(result));

        var resultSaved = handle !== 'question-4' || (Boolean(result) && readResult() === result);
        if (!stateSaved || !resultSaved || !config.nextPath) return;

        navigationPending = true;
        window.setTimeout(function () {
          window.location.assign(config.nextPath);
        }, AUTO_ADVANCE_DELAY_MS);
      }

      card.addEventListener('click', chooseAnswer);
      card.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        chooseAnswer();
      });
    });

    var initiallyEnabled = Boolean(selected);
    if (handle === 'question-4') {
      var initialResult = calculateResult(state);
      writeResult(initialResult);
      initiallyEnabled = Boolean(initialResult);
    }
    setContinueEnabled(continueLink, initiallyEnabled);

    continueLink.addEventListener('click', function (event) {
      if (continueLink.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
      }
    });

    continueLink.addEventListener('keydown', function (event) {
      if (continueLink.getAttribute('aria-disabled') === 'true' && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
      }
    });
  }

  function initializeLoading() {
    var result = readResult();
    var destination = result ? RESULT_PATHS[result] : FALLBACK_PATH;

    window.setTimeout(function () {
      window.location.assign(destination);
    }, LOADING_DELAY_MS);
  }

  function initialize() {
    var handle = currentHandle();
    if (handle === 'loading') {
      initializeLoading();
      return;
    }

    if (PAGES[handle]) initializeQuestion(handle, PAGES[handle]);
  }

  initialize();
})();
